"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GeoMarkStatus;
(function (GeoMarkStatus) {
    GeoMarkStatus["Reserved"] = "Reserved";
    GeoMarkStatus["Booked"] = "Booked";
    GeoMarkStatus["Paid"] = "Paid";
    GeoMarkStatus["Sold"] = "Sold";
    GeoMarkStatus["Deleted"] = "Deleted";
    GeoMarkStatus["Free"] = "Free";
    GeoMarkStatus["_FreeOnlyForFrontend"] = "_FreeOnlyForFrontend";
})(GeoMarkStatus = exports.GeoMarkStatus || (exports.GeoMarkStatus = {}));
//# sourceMappingURL=GeoMarks.js.map